import React, { useCallback } from 'react';
import Typography from '@material-ui/core/Typography';
import useTranslation from "../translation";


export function InputRadio({ name, errors, register }) {
    const { onChange, ref } = register(name);
    const translation = useTranslation();
    
    const onRadioChange = useCallback(async (event) => {
        onChange(event);
    }, []);

    return (
        <>     
            <div className="radio-group">
                <label className="radio" >
                    <input
                        type="radio"
                        id={`${name}-1`}
                        ref={ref}
                        value="1"
                        {...register(name)}
                        onChange={onRadioChange}
                        className="radio"
                        aria-label="Ja"
                    />
                    <span>{translation.yes}</span>
                </label>

                <label className="radio" >
                    <input
                        type="radio"
                        id={`${name}-2`}
                        ref={ref}
                        value="0"
                        {...register(name)}
                        onChange={onRadioChange}
                        className="radio"
                        aria-label="Nej"
                    />
                    <span>{translation.no}</span>
                </label>
            </div>
            <br />
            <Typography color="error" variant="caption"> {errors[name] && translation.select_error} </Typography>

        </>
    );
}